import { render } from "./WallpaperPreviewDialog.vue?vue&type=template&id=45257dd0&scoped=true"
import script from "./WallpaperPreviewDialog.vue?vue&type=script&lang=js"
export * from "./WallpaperPreviewDialog.vue?vue&type=script&lang=js"

import "./WallpaperPreviewDialog.vue?vue&type=style&index=0&id=45257dd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45257dd0"]])

export default __exports__